import { render } from "./AppPromotionsModal.vue?vue&type=template&id=570ac356&scoped=true"
import script from "./AppPromotionsModal.vue?vue&type=script&lang=js"
export * from "./AppPromotionsModal.vue?vue&type=script&lang=js"

import "./AppPromotionsModal.vue?vue&type=style&index=0&id=570ac356&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570ac356"]])

export default __exports__